import { render } from "./ShippingOption.vue?vue&type=template&id=e5c098a2&scoped=true"
import script from "./ShippingOption.vue?vue&type=script&lang=js"
export * from "./ShippingOption.vue?vue&type=script&lang=js"

import "./ShippingOption.vue?vue&type=style&index=0&id=e5c098a2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5c098a2"]])

export default __exports__